import { VEHICLE_TYPES } from '../../constants/constTypes';
import {
    readSafeJsonArray,
    writeSafeJsonArray,
    subscribeStorageKey,
} from './safeStorage';

const STORAGE_KEY = 'guestFavorites';
const EVENT_NAME = 'guestFavoritesChanged';

const ALLOWED_TYPES = new Set([
    VEHICLE_TYPES.CAR,
    VEHICLE_TYPES.BIKE,
    VEHICLE_TYPES.COMMERCIAL,
    'parts',
]);

const writeAndNotify = (items) => {
    writeSafeJsonArray(STORAGE_KEY, items);
    if (typeof window !== 'undefined') {
        try {
            window.dispatchEvent(new CustomEvent(EVENT_NAME));
        } catch {}
    }
};

const keyOf = (entry) => `${entry.type}:${String(entry.id)}`;

export const getGuestFavorites = () =>
    readSafeJsonArray(STORAGE_KEY).filter(
        (i) => i && typeof i.id !== 'undefined' && ALLOWED_TYPES.has(i.type),
    );

export const hasGuestFavorite = ({ id, type }) => {
    if (!id || !ALLOWED_TYPES.has(type)) return false;
    const target = keyOf({ id, type });
    return getGuestFavorites().some((i) => keyOf(i) === target);
};

export const addGuestFavorite = ({ id, type }) => {
    if (!id || !ALLOWED_TYPES.has(type)) return;
    const target = keyOf({ id, type });
    const items = getGuestFavorites().filter((i) => keyOf(i) !== target);
    items.unshift({ id: String(id), type, ts: Date.now() });
    writeAndNotify(items);
};

export const removeGuestFavorite = ({ id, type }) => {
    if (!id || !ALLOWED_TYPES.has(type)) return;
    const target = keyOf({ id, type });
    writeAndNotify(getGuestFavorites().filter((i) => keyOf(i) !== target));
};

export const clearGuestFavorites = () => writeAndNotify([]);

export const subscribeGuestFavorites = (handler) =>
    subscribeStorageKey(STORAGE_KEY, EVENT_NAME, handler);
